import { api } from './customers'

export interface CustomerPeriod {
    data:any
    mensturalCycle:any
}
export interface CustomerMedical {
    id:number
    customerId: number
    ivf: number
    ivfYear: number
    ivfMonth: number
    iui: number
    iuiYear: number
    iuiMonth: number
    icsi: number
    icsiYear: number
    icsiMonth: number
    miscarriages: number
    miscarriagesYear: number
    miscarriagesMonth: number
    children: number 
    childrenONE: number
    childrenTWO: number
    childrenTHREE: number
    lmp: string, 
    healthIssues: string 
    spouseHealthIssues: string
    occupation: string
    spouseOccupation: string
    areaOfInterest: string
    status: number
}

type CustomerMedicalsResponse = CustomerMedical[]
type CustomerPeriodResponse = CustomerPeriod[]



export const customerMedicalApi = api.injectEndpoints({
    endpoints: (build) => ({
        getCustomerMedicals: build.query<CustomerMedicalsResponse, void>({
            query: () => 'medical_details',
            providesTags: (result) =>
                result
                    ? [
                        ...result["data"]?.map(({ id }) => ({ type: 'CustomerMedical' as const, id })),
                        { type: 'CustomerMedical', id: 'LIST' },
                    ]
                    : [{ type: 'CustomerMedical', id: 'LIST' }],
        }),
        getCustomerPeriodTracker: build.query<CustomerPeriod, string>({
            query: (id) => `period_tracker/${id}`,
            transformResponse: (response: { data: CustomerPeriod }, meta, arg) => response.data,

        }),
        addCustomerPeriod: build.mutation<CustomerPeriod, Partial<CustomerPeriod>>({
            query: (body) => ({
                url: `period_tracker`,
                method: 'POST',
                body,
            }),
            invalidatesTags: [{ type: 'Customer', id: 'LIST' },{ type: 'DasboardCustomers', id: 'LIST' }],
        }),
        addCustomerMedical: build.mutation<CustomerMedical, Partial<CustomerMedical>>({
            query: (body) => ({
                url: `medical_details`,
                method: 'POST',
                body,
            }),
            invalidatesTags: [{ type: 'Customer', id: 'LIST' },{ type: 'DasboardCustomers', id: 'LIST' }],
        }),
         addCycleIq: build.mutation<any, Partial<any>>({
            query: (body) => ({
                url: `cycleiq`,
                method: 'POST',
                body,
            }),
            invalidatesTags: [{ type: 'Customer', id: 'LIST' },{ type: 'DasboardCustomers', id: 'LIST' }],
        }),

        getCustomerMedical: build.query<CustomerMedical, string>({
            query: (id) => `get_medical_detailsBycustomerID/${id}`,
            transformResponse: (response: { data: CustomerMedical }, meta, arg) => response.data,
        }),
        getCustomerCycleIQ: build.query<CustomerMedical, string>({
            query: (id) => `/cycleiq_customer/${id}`,
            transformResponse: (response: { data: CustomerMedical }, meta, arg) => response.data,
        }),
        updateCustomerMedical: build.mutation<void, Pick<CustomerMedical, 'id'> & Partial<CustomerMedical>>({
            query: ({ id, ...patch }) => ({
                url: `medical_details/${id}`,
                method: 'PUT',
                body: patch,
            }),
            invalidatesTags: [{ type: 'Customer', id: 'LIST' },{ type: 'DasboardCustomers', id: 'LIST' }],
        }),
         updateCycleIq : build.mutation<void, Pick<CustomerMedical, 'id'> & Partial<CustomerMedical>>({
            query: ({ id, ...patch }) => ({
                url: `cycleiq/${id}`,
                method: 'PUT',
                body: patch,
            }),
            invalidatesTags: [{ type: 'Customer', id: 'LIST' },{ type: 'DasboardCustomers', id: 'LIST' }],
        }),
        deleteCustomerMedical: build.mutation<{ success: boolean; id: number }, number>({
            query(id) {
                return {
                    url: `medical_details/${id}`,
                    method: 'DELETE',
                }
            },
            invalidatesTags: [{ type: 'Customer', id: 'LIST' },{ type: 'DasboardCustomers', id: 'LIST' }],
        }),
    }),
})

export const {
    useGetCustomerMedicalQuery,
    useGetCustomerPeriodTrackerQuery,
    useGetCustomerMedicalsQuery,
    useAddCustomerMedicalMutation,
    useUpdateCustomerMedicalMutation,
    useGetCustomerCycleIQQuery,
    useAddCycleIqMutation,
    useUpdateCycleIqMutation,
    useAddCustomerPeriodMutation,
    useDeleteCustomerMedicalMutation,
} = customerMedicalApi

